"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannel = exports.isMiniprogramOnly = exports.isJDDoctor = exports.isNKApp = exports.isJDApp = exports.isJDHApp = exports.getUa = void 0;
var getGlobalWindow_1 = require("./getGlobalWindow");
var nethpMini_1 = require("./nethpMini");
var wxTool_1 = require("./wxTool");
var jdmin_1 = require("./jdmin");
// const getUa = () => global?.navigator?.userAgent || (global as any).userAgent || '';
// 出于缓存考虑只在客户端使用useragent
var getUa = function () {
    var _a;
    var wd = (0, getGlobalWindow_1.getWindow)();
    return ((_a = wd === null || wd === void 0 ? void 0 : wd.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || "";
};
exports.getUa = getUa;
// 判断是否京东健康app环境
var isJDHApp = function () {
    var UA = (0, exports.getUa)();
    var isJDHAppFlag = UA.toLowerCase().indexOf("jdhapp");
    if (isJDHAppFlag > -1) {
        return true;
    }
    return false;
};
exports.isJDHApp = isJDHApp;
// 判断是否京东app环境
var isJDApp = function () {
    var UA = (0, exports.getUa)();
    var isJDAppFlag = UA.toLowerCase().indexOf("jdapp");
    if (isJDAppFlag > -1) {
        return true;
    }
    return false;
};
exports.isJDApp = isJDApp;
//  判断是否是南开环境
var isNKApp = function () {
    var UA = (0, exports.getUa)();
    var isNKAppFlag = UA.toLowerCase().indexOf("nk_patient");
    if (isNKAppFlag > -1) {
        return true;
    }
    return false;
};
exports.isNKApp = isNKApp;
function isJDDoctor() {
    var UA = (0, exports.getUa)();
    return UA.toLowerCase().indexOf("jdDoctor") > -1;
}
exports.isJDDoctor = isJDDoctor;
function isMiniprogramOnly() {
    //是否是在小程序的webview中
    var UA = (0, exports.getUa)();
    var isMiniAppFlag = UA.toLowerCase().indexOf("miniprogram");
    if (isMiniAppFlag > -1) {
        return true;
    }
    return false;
}
exports.isMiniprogramOnly = isMiniprogramOnly;
var getChannel = function () {
    // (1：网站，2：手机APP，3：M端，4：手Q，5：微信，6：手机浏览器,7：小程序, 13: 互医小程序) //2018年8月7日15:51:10 为了诊后管理都是在微信端，所以判断下
    var ua = (0, exports.getUa)();
    var channel = 3;
    channel = (0, wxTool_1.isWeiXin)() ? 5 : channel;
    channel = /AND_SQ|IPH_SQ/i.test(ua) ? 4 : channel;
    channel = ua.indexOf("jdapp") !== -1 ? 2 : channel;
    if (ua.toLowerCase().includes("miniprogram")) {
        if ((0, jdmin_1.isJdMin)() || (0, jdmin_1.isJdMinHalf)()) {
            // 京购小程序或京购下的处方半屏
            channel = 20;
        }
        else if ((0, nethpMini_1.isNethpMini)()) {
            channel = 13;
        }
        else if ((0, nethpMini_1.isFamdocMini)()) {
            // 家医&互医小程序兼容：如果cookie中有这个标识 提单标识为19 表示从家医小程序引的单
            channel = 19;
        }
        else {
            channel = 7;
        }
    }
    if (ua.toLowerCase().includes("angelcare")) {
        channel = 8;
    }
    if (ua.toLowerCase().includes("jdhapp")) {
        channel = 11;
    }
    if (ua.toLowerCase().includes("jdpingou")) {
        channel = 15; // 京喜渠道
    }
    if (ua.toLowerCase().includes("jdlocal")) {
        channel = 16; //京东到家渠道
    }
    console.log("channel: ", channel);
    return channel;
};
exports.getChannel = getChannel;
